// CANDIDATE QUESTIONS
import {jobs} from "../constants/Lists.js";
import {
  INTERVIEW_RECORDING_PREFERENCE_ALWAYS,
  INTERVIEW_RECORDING_PREFERENCE_ASK,
  INTERVIEW_RECORDING_PREFERENCE_NEVER
} from "../constants/Interviews.js";

export const candidateProfilePhoto = {
  path: {
    title: "Profile Photo",
    storeField: "profilePhoto",
    type: "image",
  },
};

export const candidateBasicInfo = {
  aboutMe: {
    title: "Short About Me",
    storeField: "about",
    type: "textarea",
    recommendedCharacterLength: 150,
    maxLength: 750,
  },
  location: {
    title: "Find Jobs Near",
    storeField: "location",
    type: "city",
  },
  willingToRelocate: {
    title: "Relocation Preference",
    storeField: "willingToRelocate",
    type: "enum",
    enum: ["Open to Relocate", "Might Relocate", "No Relocation"],
  },
  remote: {
    title: "Remote Work Preference",
    storeField: "remote",
    type: "enum",
    enum: ["Open to Remote", "Remote Only", "No Remote"],
  },
  interestedIn: {
    title: "Seeking Jobs As",
    storeField: "interestedIn",
    type: "pill",
    pillType: "jobs",
    searchable: true,
    customizable: true,
    presets: true,
    max: 50,
  },
  industry: {
    title: "Industries",
    storeField: "industries",
    type: "pill",
    pillType: "industries",
    presets: true,
    searchable: false,
    customizable: false,
    max: 5,
  },
  sponsorship: {
    title: "Sponsorship Required",
    storeField: "requiresSponsorship",
    type: "boolean",
    description: "Will you now or in the future require an Employment Visa Sponsorship?",
  },
  fullTime: {
    title: "Employment Type",
    storeField: "fullTime",
    type: "checkboxes",
    options: ["Full Time", "Part Time", "Contract", "Internship", "Temporary"],
  },
  availability: {
    title: "Availability",
    storeField: "availability",
    type: "checkboxes",
    options: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
  },
  minCompensation: {
    title: "Desired Compensation",
    storeField: "desiredHourlyPay",
    type: "pay",
  },
  prompt: {
    title: "Answer a Prompt",
    storeField: "summary",
    type: "prompt",
    prompts: [
      "What is your proudest accomplishment?",
      "Do you like or dislike surprises? Why or why not?",
      "What’s something new you’d like to learn?",
      "Do you have any hidden talents or hobbies?",
      "Who inspires you?",
      "What is something that motivates you?",
    ],
  },
};

export const candidateExceptionalAbility = {
  top3: {
    title: "Top 3 Points of Exceptional Ability",
    storeField: "exceptionalAbility",
    examples: [
      "e.g. Great communicator",
      "e.g. Strong work ethic",
      "e.g. Team player",
    ],
    type: "bullet",
    maxItems: 3,
    maxLength: 44,
  },
};

export const candidateVideo = {
  profileVideo1: {
    title: "First Profile Video",
    storeField: "profileVideo1",
    type: "video",
    prompts: [
      "How would other people describe you?",
      "What is something about you that people would be surprised to know?",
      "What is your approach to maintaining effective communication?",
      "Would you consider yourself an extrovert or an introvert and why?",
      "What is one skill that sets you apart?",
      "What type of management style works best for you? ",
      "If you were stranded on a deserted island, what two items would you bring with you?",
    ],
    videoPrompts: [
      "https://resources.businessdraft.com/candidate-question-1.mp4",
      "https://resources.businessdraft.com/candidate-question-2.mp4",
      "https://resources.businessdraft.com/candidate-question-3.mp4",
      "https://resources.businessdraft.com/candidate-question-4.mp4",
      "https://resources.businessdraft.com/candidate-question-5.mp4",
      "https://resources.businessdraft.com/candidate-question-6.mp4",
      "https://resources.businessdraft.com/candidate-question-7.mp4",
      "https://resources.businessdraft.com/candidate-question-8.mp4",
    ],
  },
  profileVideo2: {
    title: "Second Profile Video",
    storeField: "profileVideo2",
    type: "video",
    prompts: [
      "How would other people describe you?",
      "What is something about you that people would be surprised to know?",
      "What is your approach to maintaining effective communication?",
      "Would you consider yourself an extrovert or introvert and why?",
      "What type of management style works best for you? ",
      "If you were stranded on a deserted island, what two items would you bring with you?",
      "When you’re having a bad day, what do you do to make yourself feel better?",
    ],
    videoPrompts: [
      "https://resources.businessdraft.com/candidate-question-1.mp4",
      "https://resources.businessdraft.com/candidate-question-2.mp4",
      "https://resources.businessdraft.com/candidate-question-3.mp4",
      "https://resources.businessdraft.com/candidate-question-4.mp4",
      "https://resources.businessdraft.com/candidate-question-5.mp4",
      "https://resources.businessdraft.com/candidate-question-6.mp4",
      "https://resources.businessdraft.com/candidate-question-7.mp4",
      "https://resources.businessdraft.com/candidate-question-8.mp4",
    ],
  },
};

export const candidateSkillsAccomplishments = {
  skills: {
    title: "Skills",
    storeField: "skills",
    type: "list",
    allows: {
      title: "Skill title",
      rank: "Rank your skill",
    },
    max: 15
  },
  accomplishments: {
    title: "Accomplishments",
    icon: "trophy",
    storeField: "accomplishments",
    type: "list",
    allows: {
      title: "Accomplishment title",
    },
    max: 15
  },
};

export const candidateCareerPassport = {
  passport: {
    title: "Career Passport Entries",
    storeField: "careerPassport",
    type: "list",
    allows: {
      primaryList: "Position title",
      getPrimaryList: (params) => jobs(params),
      title: "Company name",
      start: "Start date",
      end: "End date",
      description: "Short Description",
      completion: ["No Longer Working Here", "Currently Working Here"],
      tenure: "Tenure",
    },
    max: 25
  },
};

export const candidateEducationBadges = {
  education: {
    title: "Education",
    storeField: "education",
    type: "list",
    allows: {
      primary: "Field of study (Optional)",
      title: "School name",
      start: "Start date",
      end: "End date",
      description: "Biggest takeaway (Optional)",
      completion: ["Partially Completed", "Currently Attending", "Graduated"],
      type: [
        "High School/GED",
        "Associate's Degree",
        "Bachelor's Degree",
        "Master's Degree",
        "Other",
      ],
      honors: "I maintained an 'Honors' Academic Status (Optional)",
    },
    max: 25
  },
  licenses: {
    title: "Certificates, Certifications, and Licenses",
    storeField: "certificatesCertificationsAndLicenses",
    type: "fileList",
    allows: {
      title: "Certificate, Certification, or License Name",
      file: "Upload your certificate, certification, or license",
    },
    mimes: "image/jpeg, image/jpg, image/png, image/webp, application/pdf",
    max: 5,
  },
  languages: {
    title: "Languages",
    storeField: "languages",
    type: "pill",
    pillType: "languages",
    searchable: true,
    customizable: false,
    presets: true,
    max: 25,
  },
  studentAthlete: {
    title: "Student Athlete",
    storeField: "studentAthlete",
    type: "boolean",
  },
  hobbies: {
    title: "Hobbies",
    storeField: "hobbies",
    type: "textarea",
    maxLength: 255,
    recommendedCharacterLength: 50,
  },
  military: {
    title: "Served in Military",
    storeField: "military",
    type: "boolean",
  },
};

export const candidateSocials = {
  linkedIn: {
    title: "LinkedIn",
    storeField: "linkedIn",
    type: "string",
    inputMode: "url",
    format: "handle",
    placeholder: "your-linked-in-handle",
    prefixes: [
      "https://linkedin.com/in/",
      "https://linkedin.com/company/"
    ],
    defaultPrefix: "https://linkedin.com/in/",
    dropdownWidthClass: "w-80",
    isLink: true,
  },
  instagram: {
    title: "Instagram",
    storeField: "instagram",
    type: "string",
    inputMode: "url",
    format: "handle",
    placeholder: "your-instagram-handle",
    prefixes: ["https://instagram.com/"],
    defaultPrefix: "https://instagram.com/",
    dropdownWidthClass: "w-80",
    isLink: true,
  },
  facebook: {
    title: "Facebook",
    storeField: "facebook",
    type: "string",
    inputMode: "url",
    format: "handle",
    placeholder: "your-facebook-handle",
    prefixes: ["https://facebook.com/"],
    defaultPrefix: "https://facebook.com/",
    dropdownWidthClass: "w-80",
    isLink: true,
  },
  website: {
    title: "Website",
    storeField: "website",
    type: "string",
    inputMode: "url",
    format: "website",
    placeholder: "your-website.com",
    prefixes: ["https://", "http://"],
    defaultPrefix: "https://",
    dropdownWidthClass: "w-32",
    isLink: true,
  },
};

// COMPANY QUESTIONS

export const companyBasicInfo = {
  dba: {
    title: "Company Name / DBA",
    storeField: "name",
    type: "string",
  },
  nickname: {
    title: "Location Nickname",
    storeField: "nickname",
    type: "string",
  },
  email: {
    title: "Company Hiring Email",
    storeField: "email",
    type: "string",
    inputType: "email",
  },
  phone: {
    title: "Company Phone",
    storeField: "phone",
    type: "string",
    format: "phone",
  },
  location: {
    title: "Company Headquarters",
    storeField: "location",
    type: "location",
  },
  description: {
    title: "Company Description",
    storeField: "description",
    type: "html",
    defaultHeight: 512,
  },
  industries: {
    title: "Industry",
    storeField: "industries",
    type: "pill",
    pillType: "industries",
    presets: true,
    searchable: false,
    customizable: false,
  },
  companySize: {
    title: "Employees",
    storeField: "companySize",
    type: "enum",
    enum: ["1 - 10", "10 - 50", "50 - 100", "100 - 250", "250 - 1,000", "1,000 - 5,000", "5,000 - 10,000", "10,000 - 25,000", "25,000+"],
  },
  yearFounded: {
    title: "Founded In",
    storeField: "yearFounded",
    type: "string",
    placeholder: "e.g. 2009"
  },
};

export const companyValues = {
  missionStatement: {
    title: "Mission Statement",
    storeField: "missionStatement",
    type: "textarea",
    maxLength: 1024,
    recommendedCharacterLength: 150,
  },
  coreValues: {
    title: "Core Values",
    storeField: "coreValues",
    type: "bullet",
    maxItems: 3,
    examples: ["e.g. Integrity", "e.g. Teamwork", "e.g. Innovation"]
  },
};

export const companyBranding = {
  colors: {
    title: "Company Colors",
    storeField: "primaryForegroundColor",
    type: "colors",
  },
  avatar: {
    title: "Company Profile Picture",
    storeField: "fileAvatar",
    width: 512,
    height: 512,
    rounded: true,
    type: "image",
    useCase: "This is the icon that will be displayed on the company profile page",
    previewBackgroundColor: ["#fff", "#000"],
  },
  logo: {
    title: "Company Logo",
    storeField: "fileLogo",
    maxSizeKb: 4194304,
    type: "image",
    useCase: "This logo will be used in offer letters and emails that your company sends through the Business Draft",
    previewBackgroundColor: "#fff"
  },
  banner: {
    title: "Company Banner",
    storeField: "fileBanner",
    width: 1584,
    height: 396,
    type: "image",
    useCase: "This is the banner that will be displayed on the company profile page"
  },
};

export const companyMedia = {
  profileVideo1: {
    title: "Company Video #1",
    storeField: "video1",
    type: "video",
    prompts: [
      "What is your company's approach to maintaining effective communication?",
      "What is one thing that sets your company apart from the competition?",
      "How would you describe your company culture and values?",
      "What is the long term vision and growth strategy of the company?",
      "How does your company handle remote and flexible work arrangements?",
      "How does your company handle feedback and performance evaluations?",
      "What opportunities are there for advancement in the company?",
      "What is the companies approach to continued education and professional development?",
    ],
  },
  profileVideo2: {
    title: "Company Video #2",
    storeField: "video2",
    type: "video",
    prompts: [
      "What is your company's approach to maintaining effective communication?",
      "What is one thing that sets your company apart from the competition?",
      "How would you describe your company culture and values?",
      "What is the long term vision and growth strategy of the company?",
      "How does your company handle remote and flexible work arrangements?",
      "How does your company handle feedback and performance evaluations?",
      "What opportunities are there for advancement in the company?",
      "What is the companies approach to continued education and professional development?",
    ],
  },
  image1: {
    title: "Company Image #1",
    storeField: "fileImage1",
    maxSizeKb: 4194304,
    type: "image",
    useCase: "Ideas: this could be a picture of the office, or a picture of the team, or a picture of the product you sell."
  },
  image2: {
    title: "Company Image #2",
    storeField: "fileImage2",
    maxSizeKb: 4194304,
    type: "image",
    useCase: "Ideas: this could be a picture of the office, or a picture of the team, or a picture of the product you sell."
  },
  image3: {
    title: "Company Image #3",
    storeField: "fileImage3",
    maxSizeKb: 4194304,
    type: "image",
    useCase: "Ideas: this could be a picture of the office, or a picture of the team, or a picture of the product you sell."
  },
  image4: {
    title: "Company Image #4",
    storeField: "fileImage4",
    maxSizeKb: 4194304,
    type: "image",
    useCase: "Ideas: this could be a picture of the office, or a picture of the team, or a picture of the product you sell."
  },
  image5: {
    title: "Company Image #5",
    storeField: "fileImage5",
    maxSizeKb: 4194304,
    type: "image",
    useCase: "Ideas: this could be a picture of the office, or a picture of the team, or a picture of the product you sell."
  },
};

export const companySocials = {
  linkedIn: {
    title: "LinkedIn",
    storeField: "linkedIn",
    type: "string",
    inputMode: "url",
    format: "handle",
    placeholder: "your-linked-in-handle",
    prefixes: [
      "https://linkedin.com/in/",
      "https://linkedin.com/company/"
    ],
    defaultPrefix: "https://linkedin.com/in/",
    dropdownWidthClass: "w-80",
    isLink: true,
  },
  instagram: {
    title: "Instagram",
    storeField: "instagram",
    type: "string",
    inputMode: "url",
    format: "handle",
    placeholder: "your-instagram-handle",
    prefixes: ["https://instagram.com/"],
    defaultPrefix: "https://instagram.com/",
    dropdownWidthClass: "w-80",
    isLink: true,
  },
  facebook: {
    title: "Facebook",
    storeField: "facebook",
    type: "string",
    inputMode: "url",
    format: "handle",
    placeholder: "your-facebook-handle",
    prefixes: ["https://facebook.com/"],
    defaultPrefix: "https://facebook.com/",
    dropdownWidthClass: "w-80",
    isLink: true,
  },
  website: {
    title: "Website",
    storeField: "website",
    type: "string",
    inputMode: "url",
    format: "website",
    placeholder: "your-website.com",
    prefixes: ["https://", "http://"],
    defaultPrefix: "https://",
    dropdownWidthClass: "w-32",
    isLink: true,
  },
};

export const companySettings = {
  interviewRecordingPreference: {
    title: "Interview Recording Preference",
    storeField: "interviewRecordingPreference",
    type: "enum",
    enum: [
      {name: "Always Record", value: INTERVIEW_RECORDING_PREFERENCE_ALWAYS},
      {name: "Never Record", value: INTERVIEW_RECORDING_PREFERENCE_NEVER},
      {name: "Ask Interviewer", value: INTERVIEW_RECORDING_PREFERENCE_ASK},
    ],
  },
  indeedEnabled: {
    title: "Indeed Integration Enabled",
    description: "By default, we forward all your job opportunities to Indeed, free of charge. If you would like us to not post your jobs to Indeed, please select 'NO'.",
    storeField: "indeedEnabled",
    type: "boolean",
  },
  indeedApplyEnabled: {
    title: "Indeed Apply Enabled",
    description: "By default, we allow candidates to apply directly on Indeed.com. If you would rather have them apply on Business Draft, please select 'NO'.",
    storeField: "indeedApplyEnabled",
    type: "boolean",
  }
};
